import React, { useState, useEffect } from "react";
import {
  Box,
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TextField,
  IconButton,
  Button,
  useMediaQuery,
  useTheme,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Grid,
  Card,
  CardContent,
  TablePagination,
  MenuItem,
  FormControl,
  Select,
  InputAdornment,
  Autocomplete
} from "@mui/material";
import { 
  Add, 
  Save, 
  Cancel, 
  Edit, 
  Delete, 
  Visibility,
  Close,
  Work
} from "@mui/icons-material";
import axios from "axios";

const WorkExperience = () => {
  const [experiences, setExperiences] = useState([]);
  const [newExperience, setNewExperience] = useState({
    companyName: "",
    previousDesignation: "",
    tenureFrom: "",
    tenureTo: "",
    lastCTC: "",
    collegeUniversity: ""
  });
  const [editingId, setEditingId] = useState(null);
  const [showAddRow, setShowAddRow] = useState(false);
  const [viewDialogOpen, setViewDialogOpen] = useState(false);
  const [selectedExperience, setSelectedExperience] = useState(null);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.down('md'));

  // Currency Options
  const currencyOptions = ["₹ INR", "$ USD", "€ EUR", "£ GBP"];
  const [currency, setCurrency] = useState("₹ INR");

  // Company Suggestions for Autocomplete
  const companySuggestions = [
    "Infosys", "TCS", "Wipro", "HCL", "Accenture",
    "IBM", "Microsoft", "Google", "Amazon", "Facebook",
    "Capgemini", "Cognizant", "Deloitte", "EY", "PwC",
    "KPMG", "Oracle", "SAP", "Adobe", "Salesforce"
  ];

  const handleNewExperienceChange = (field, value) => {
    setNewExperience(prev => ({ ...prev, [field]: value }));
  };

  const handleExperienceChange = (id, field, value) => {
    setExperiences(prev =>
      prev.map(exp =>
        exp.id === id ? { ...exp, [field]: value } : exp
      )
    );
  };

  const handleAddNew = async () => {
    if (newExperience.companyName && newExperience.previousDesignation && newExperience.tenureFrom) {
      try {
        // Format the data with currency
        const experienceData = {
          ...newExperience,
          lastCTC: newExperience.lastCTC ? `${currency} ${newExperience.lastCTC}` : ""
        };

        const response = await axios.post(
          "http://10.10.222.56:8283/experience/AddExperience",
          experienceData
        );

        if (response.data.success) {
          setExperiences([{ 
            ...experienceData, 
            id: Date.now(),
            lastCTC: newExperience.lastCTC ? `${currency} ${newExperience.lastCTC}` : "" 
          }, ...experiences]);
          
          setNewExperience({
            companyName: "",
            previousDesignation: "",
            tenureFrom: "",
            tenureTo: "",
            lastCTC: "",
            collegeUniversity: ""
          });
          setShowAddRow(false);
          alert("Work experience added successfully!");
        } else {
          console.error("Failed to add work experience:", response.data.message);
          alert("Failed to add work experience. Please try again.");
        }
      } catch (error) {
        console.error("Error adding work experience:", error);
        alert("Error adding work experience. Please check your connection.");
      }
    } else {
      alert("Company Name, Previous Designation, and Tenure From are required fields!");
    }
  };

  const handleEdit = (id) => {
    setEditingId(id);
  };

  const handleSave = async (id) => {
    const experienceToUpdate = experiences.find(exp => exp.id === id);
    if (experienceToUpdate) {
      try {
        // Extract numeric value from lastCTC
        let lastCTCValue = experienceToUpdate.lastCTC;
        if (lastCTCValue && typeof lastCTCValue === 'string') {
          lastCTCValue = lastCTCValue.replace(/[^0-9.]/g, '');
        }

        const updateData = {
          ...experienceToUpdate,
          lastCTC: experienceToUpdate.lastCTC ? `${currency} ${lastCTCValue}` : ""
        };

        const response = await axios.put(
          `http://10.10.222.56:8283/experience/UpdateExperience/${id}`,
          updateData
        );

        if (response.data.success) {
          // Update local state with currency
          handleExperienceChange(id, "lastCTC", updateData.lastCTC);
          setEditingId(null);
          alert("Work experience updated successfully!");
        } else {
          console.error("Failed to update work experience:", response.data.message);
          alert("Failed to update work experience.");
        }
      } catch (error) {
        console.error("Error updating work experience:", error);
        alert("Error updating work experience.");
      }
    }
  };

  const handleCancel = () => {
    setEditingId(null);
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this work experience?")) {
      try {
        const response = await axios.delete(
          `http://10.10.222.56:8283/experience/DeleteExperience/${id}`
        );

        if (response.data.success) {
          setExperiences(prev => prev.filter(exp => exp.id !== id));
          alert("Work experience deleted successfully!");
        } else {
          console.error("Failed to delete work experience:", response.data.message);
          alert("Failed to delete work experience.");
        }
      } catch (error) {
        console.error("Error deleting work experience:", error);
        alert("Error deleting work experience.");
      }
    }
  };

  const handleView = (experience) => {
    setSelectedExperience(experience);
    setViewDialogOpen(true);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const calculateTenure = (fromDate, toDate) => {
    if (!fromDate) return "";
    
    const from = new Date(fromDate);
    const to = toDate ? new Date(toDate) : new Date();
    
    const years = to.getFullYear() - from.getFullYear();
    const months = to.getMonth() - from.getMonth();
    
    let totalMonths = years * 12 + months;
    if (totalMonths < 0) totalMonths = 0;
    
    const yearsPart = Math.floor(totalMonths / 12);
    const monthsPart = totalMonths % 12;
    
    let result = "";
    if (yearsPart > 0) result += `${yearsPart} year${yearsPart > 1 ? 's' : ''}`;
    if (monthsPart > 0) {
      if (result) result += " ";
      result += `${monthsPart} month${monthsPart > 1 ? 's' : ''}`;
    }
    if (!result) result = "Less than a month";
    
    return result;
  };

  const formatCurrency = (value) => {
    if (!value) return "";
    return value;
  };

  useEffect(() => {
    const fetchWorkExperiences = async () => {
      try {
        const response = await axios.get("http://10.10.222.56:8283/experience/GetExperiences/1");
        if (response.data.success) {
          setExperiences(response.data.data);
        }
      } catch (error) {
        console.error("Error fetching work experiences:", error);
        // alert("Error fetching work experiences. Please check your connection.");
      }
    };

    fetchWorkExperiences();
  }, []);

  // Responsive table header
  const tableHeaders = isMobile
    ? ["S.NO", "Company", "Designation", "Tenure", "Last CTC", "Actions"]
    : ["S.NO", "Company Name", "Previous Designation", "Tenure (From)", "Tenure (To)", "Last CTC", "College/University", "Actions"];

  // Mobile View - Card layout
  if (isMobile) {
    return (
      <Box>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
          <Typography variant="h6" component="h2">
            Work Experience
          </Typography>
          <Button
            variant="contained"
            startIcon={<Add />}
            onClick={() => setShowAddRow(true)}
            size="small"
          >
            Add Experience
          </Button>
        </Box>

        {showAddRow && (
          <Card sx={{ mb: 2, bgcolor: '#f5f5f5' }}>
            <CardContent>
              <Typography variant="subtitle1" gutterBottom>
                Add New Work Experience
              </Typography>
              <Grid container spacing={1}>
                <Grid item xs={12}>
                  <Autocomplete
                    freeSolo
                    options={companySuggestions}
                    value={newExperience.companyName}
                    onChange={(event, newValue) => {
                      handleNewExperienceChange("companyName", newValue || "");
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Company Name *"
                        size="small"
                        required
                        fullWidth
                      />
                    )}
                  />
                </Grid>

                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Previous Designation *"
                    size="small"
                    value={newExperience.previousDesignation}
                    onChange={(e) => handleNewExperienceChange("previousDesignation", e.target.value)}
                    required
                  />
                </Grid>
                
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="Tenure From *"
                    type="date"
                    size="small"
                    value={newExperience.tenureFrom}
                    onChange={(e) => handleNewExperienceChange("tenureFrom", e.target.value)}
                    InputLabelProps={{ shrink: true }}
                    required
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="Tenure To"
                    type="date"
                    size="small"
                    value={newExperience.tenureTo}
                    onChange={(e) => handleNewExperienceChange("tenureTo", e.target.value)}
                    InputLabelProps={{ shrink: true }}
                    helperText="Leave empty if current job"
                  />
                </Grid>
                
                <Grid item xs={12} sm={6}>
                  <Box sx={{ display: 'flex', gap: 1 }}>
                    <FormControl size="small" sx={{ minWidth: 80 }}>
                      <Select
                        value={currency}
                        onChange={(e) => setCurrency(e.target.value)}
                      >
                        {currencyOptions.map((curr) => (
                          <MenuItem key={curr} value={curr}>{curr}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                    <TextField
                      fullWidth
                      label="Last CTC"
                      size="small"
                      type="number"
                      value={newExperience.lastCTC}
                      onChange={(e) => handleNewExperienceChange("lastCTC", e.target.value)}
                      InputProps={{
                        startAdornment: <InputAdornment position="start">{currency.split(' ')[0]}</InputAdornment>,
                      }}
                    />
                  </Box>
                </Grid>
                
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="College/University"
                    size="small"
                    value={newExperience.collegeUniversity}
                    onChange={(e) => handleNewExperienceChange("collegeUniversity", e.target.value)}
                    placeholder="If this was an internship/training"
                  />
                </Grid>
                
                <Grid item xs={12}>
                  <Box sx={{ display: 'flex', gap: 1, justifyContent: 'flex-end' }}>
                    <Button
                      variant="contained"
                      onClick={handleAddNew}
                      disabled={!newExperience.companyName || !newExperience.previousDesignation || !newExperience.tenureFrom}
                      size="small"
                      startIcon={<Save />}
                    >
                      Save
                    </Button>
                    <Button
                      variant="outlined"
                      onClick={() => setShowAddRow(false)}
                      size="small"
                      startIcon={<Close />}
                    >
                      Cancel
                    </Button>
                  </Box>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        )}

        {experiences.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((exp, index) => (
          <Card key={exp.id} sx={{ mb: 1 }}>
            <CardContent>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 1 }}>
                <Box>
                  <Typography variant="subtitle1" fontWeight="bold">
                    {exp.companyName}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {exp.previousDesignation}
                  </Typography>
                </Box>
                <Typography variant="body2" color="text.secondary">
                  {page * rowsPerPage + index + 1}
                </Typography>
              </Box>

              <Grid container spacing={0.5}>
                <Grid item xs={6}>
                  <Typography variant="body2">
                    <strong>From:</strong> {exp.tenureFrom}
                  </Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography variant="body2">
                    <strong>To:</strong> {exp.tenureTo || "Present"}
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <Typography variant="body2">
                    <strong>Tenure:</strong> {calculateTenure(exp.tenureFrom, exp.tenureTo)}
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <Typography variant="body2">
                    <strong>Last CTC:</strong> {formatCurrency(exp.lastCTC) || "Not specified"}
                  </Typography>
                </Grid>
                {exp.collegeUniversity && (
                  <Grid item xs={12}>
                    <Typography variant="body2">
                      <strong>College/Univ:</strong> {exp.collegeUniversity}
                    </Typography>
                  </Grid>
                )}
              </Grid>

              <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 0.5, mt: 1 }}>
                <IconButton size="small" onClick={() => handleView(exp)}>
                  <Visibility fontSize="small" />
                </IconButton>
                <IconButton size="small" onClick={() => handleEdit(exp.id)}>
                  <Edit fontSize="small" />
                </IconButton>
                <IconButton size="small" onClick={() => handleDelete(exp.id)}>
                  <Delete fontSize="small" />
                </IconButton>
              </Box>
            </CardContent>
          </Card>
        ))}

        <TablePagination
          component="div"
          count={experiences.length}
          page={page}
          onPageChange={handleChangePage}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />

        {/* View Dialog for Mobile */}
        <Dialog open={viewDialogOpen} onClose={() => setViewDialogOpen(false)} fullWidth maxWidth="sm">
          <DialogTitle>Work Experience Details</DialogTitle>
          <DialogContent>
            {selectedExperience && (
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Typography><strong>Company Name:</strong> {selectedExperience.companyName}</Typography>
                </Grid>
                <Grid item xs={12}>
                  <Typography><strong>Previous Designation:</strong> {selectedExperience.previousDesignation}</Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography><strong>Tenure From:</strong> {selectedExperience.tenureFrom}</Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography><strong>Tenure To:</strong> {selectedExperience.tenureTo || "Present"}</Typography>
                </Grid>
                <Grid item xs={12}>
                  <Typography><strong>Total Tenure:</strong> {calculateTenure(selectedExperience.tenureFrom, selectedExperience.tenureTo)}</Typography>
                </Grid>
                <Grid item xs={12}>
                  <Typography><strong>Last CTC:</strong> {formatCurrency(selectedExperience.lastCTC) || "Not specified"}</Typography>
                </Grid>
                <Grid item xs={12}>
                  <Typography><strong>College/University:</strong> {selectedExperience.collegeUniversity || "Not applicable"}</Typography>
                </Grid>
              </Grid>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setViewDialogOpen(false)}>Close</Button>
          </DialogActions>
        </Dialog>
      </Box>
    );
  }

  // Tablet and Desktop View
  return (
    <Box>
      <Box sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        mb: 2,
        flexDirection: { xs: 'column', sm: 'row' },
        gap: { xs: 1, sm: 0 }
      }}>
        <Typography variant="h5" component="h1">
          Work Experience
        </Typography>
        <Button
          variant="contained"
          startIcon={<Add />}
          onClick={() => setShowAddRow(true)}
          sx={{ minWidth: { xs: '100%', sm: 'auto' } }}
        >
          Add  Experience
        </Button>
      </Box>

      <Paper sx={{ width: '100%', overflow: 'hidden' }}>
        <TableContainer sx={{ maxHeight: 400 }}>
          <Table stickyHeader size={isTablet ? "small" : "medium"}>
            <TableHead>
              <TableRow>
                {tableHeaders.map((header, index) => (
                  <TableCell
                    key={index}
                    align="center"
                    sx={{
                      fontWeight: "bold",
                      backgroundColor: theme.palette.primary.light,
                      color: theme.palette.primary.contrastText,
                      whiteSpace: 'nowrap',
                      padding: '8px'
                    }}
                  >
                    {header}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {showAddRow && (
                <TableRow sx={{ bgcolor: '#f9f9f9' }}>
                  <TableCell align="center" sx={{ padding: '8px' }}>-</TableCell>
                  <TableCell align="center" sx={{ padding: '8px' }}>
                    <Autocomplete
                      freeSolo
                      options={companySuggestions}
                      value={newExperience.companyName}
                      onChange={(event, newValue) => {
                        handleNewExperienceChange("companyName", newValue || "");
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          size="small"
                          fullWidth
                          placeholder="Enter company name"
                          required
                        />
                      )}
                    />
                  </TableCell>
                  <TableCell align="center" sx={{ padding: '8px' }}>
                    <TextField
                      size="small"
                      fullWidth
                      value={newExperience.previousDesignation}
                      onChange={(e) => handleNewExperienceChange("previousDesignation", e.target.value)}
                      required
                    />
                  </TableCell>
                  <TableCell align="center" sx={{ padding: '8px' }}>
                    <TextField
                      size="small"
                      type="date"
                      fullWidth
                      value={newExperience.tenureFrom}
                      onChange={(e) => handleNewExperienceChange("tenureFrom", e.target.value)}
                      InputLabelProps={{ shrink: true }}
                      required
                    />
                  </TableCell>
                  <TableCell align="center" sx={{ padding: '8px' }}>
                    <TextField
                      size="small"
                      type="date"
                      fullWidth
                      value={newExperience.tenureTo}
                      onChange={(e) => handleNewExperienceChange("tenureTo", e.target.value)}
                      InputLabelProps={{ shrink: true }}
                      placeholder="Present"
                    />
                  </TableCell>
                  <TableCell align="center" sx={{ padding: '8px' }}>
                    <Box sx={{ display: 'flex', gap: 1 }}>
                      <FormControl size="small" sx={{ minWidth: 80 }}>
                        <Select
                          value={currency}
                          onChange={(e) => setCurrency(e.target.value)}
                        >
                          {currencyOptions.map((curr) => (
                            <MenuItem key={curr} value={curr}>{curr}</MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                      <TextField
                        size="small"
                        fullWidth
                        type="number"
                        value={newExperience.lastCTC}
                        onChange={(e) => handleNewExperienceChange("lastCTC", e.target.value)}
                      />
                    </Box>
                  </TableCell>
                  <TableCell align="center" sx={{ padding: '8px' }}>
                    <TextField
                      size="small"
                      fullWidth
                      value={newExperience.collegeUniversity}
                      onChange={(e) => handleNewExperienceChange("collegeUniversity", e.target.value)}
                    />
                  </TableCell>
                  <TableCell align="center" sx={{ padding: '8px' }}>
                    <Box sx={{ display: 'flex', justifyContent: 'center', gap: 0.5 }}>
                      <IconButton
                        onClick={handleAddNew}
                        disabled={!newExperience.companyName || !newExperience.previousDesignation || !newExperience.tenureFrom}
                        color="primary"
                        size="small"
                      >
                        <Save />
                      </IconButton>
                      <IconButton
                        onClick={() => setShowAddRow(false)}
                        color="error"
                        size="small"
                      >
                        <Cancel />
                      </IconButton>
                    </Box>
                  </TableCell>
                </TableRow>
              )}

              {experiences.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((exp, index) => (
                <TableRow key={exp.id}>
                  <TableCell align="center" sx={{ padding: '8px' }}>{page * rowsPerPage + index + 1}</TableCell>
                  <TableCell align="center" sx={{ padding: '8px' }}>
                    {editingId === exp.id ? (
                      <Autocomplete
                        freeSolo
                        options={companySuggestions}
                        value={exp.companyName}
                        onChange={(event, newValue) => {
                          handleExperienceChange(exp.id, "companyName", newValue || "");
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            size="small"
                            fullWidth
                          />
                        )}
                      />
                    ) : (
                      <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
                        {exp.companyName}
                      </Typography>
                    )}
                  </TableCell>
                  <TableCell align="center" sx={{ padding: '8px' }}>
                    {editingId === exp.id ? (
                      <TextField
                        size="small"
                        fullWidth
                        value={exp.previousDesignation}
                        onChange={(e) => handleExperienceChange(exp.id, "previousDesignation", e.target.value)}
                      />
                    ) : (
                      exp.previousDesignation
                    )}
                  </TableCell>
                  <TableCell align="center" sx={{ padding: '8px' }}>
                    {editingId === exp.id ? (
                      <TextField
                        size="small"
                        type="date"
                        fullWidth
                        value={exp.tenureFrom}
                        onChange={(e) => handleExperienceChange(exp.id, "tenureFrom", e.target.value)}
                        InputLabelProps={{ shrink: true }}
                      />
                    ) : (
                      exp.tenureFrom
                    )}
                  </TableCell>
                  <TableCell align="center" sx={{ padding: '8px' }}>
                    {editingId === exp.id ? (
                      <TextField
                        size="small"
                        type="date"
                        fullWidth
                        value={exp.tenureTo}
                        onChange={(e) => handleExperienceChange(exp.id, "tenureTo", e.target.value)}
                        InputLabelProps={{ shrink: true }}
                      />
                    ) : (
                      <Typography variant="body2" sx={{ color: exp.tenureTo ? 'inherit' : theme.palette.warning.main }}>
                        {exp.tenureTo || "Present"}
                      </Typography>
                    )}
                  </TableCell>
                  <TableCell align="center" sx={{ padding: '8px' }}>
                    {editingId === exp.id ? (
                      <Box sx={{ display: 'flex', gap: 1 }}>
                        <FormControl size="small" sx={{ minWidth: 80 }}>
                          <Select
                            value={currency}
                            onChange={(e) => setCurrency(e.target.value)}
                          >
                            {currencyOptions.map((curr) => (
                              <MenuItem key={curr} value={curr}>{curr}</MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                        <TextField
                          size="small"
                          fullWidth
                          type="number"
                          value={exp.lastCTC ? exp.lastCTC.replace(/[^0-9.]/g, '') : ''}
                          onChange={(e) => handleExperienceChange(exp.id, "lastCTC", e.target.value)}
                        />
                      </Box>
                    ) : (
                      <Typography variant="body2">
                        {formatCurrency(exp.lastCTC) || "Not specified"}
                      </Typography>
                    )}
                  </TableCell>
                  <TableCell align="center" sx={{ padding: '8px' }}>
                    {editingId === exp.id ? (
                      <TextField
                        size="small"
                        fullWidth
                        value={exp.collegeUniversity}
                        onChange={(e) => handleExperienceChange(exp.id, "collegeUniversity", e.target.value)}
                      />
                    ) : (
                      <Typography variant="body2" sx={{ 
                        maxWidth: '150px', 
                        overflow: 'hidden', 
                        textOverflow: 'ellipsis', 
                        whiteSpace: 'nowrap',
                        fontStyle: exp.collegeUniversity ? 'normal' : 'italic',
                        color: exp.collegeUniversity ? 'inherit' : theme.palette.text.secondary
                      }}>
                        {exp.collegeUniversity || "Not applicable"}
                      </Typography>
                    )}
                  </TableCell>
                  <TableCell align="center" sx={{ padding: '8px' }}>
                    <Box sx={{ display: 'flex', justifyContent: 'center', gap: 0.5 }}>
                      {editingId === exp.id ? (
                        <>
                          <IconButton onClick={() => handleSave(exp.id)} size="small">
                            <Save color="primary" />
                          </IconButton>
                          <IconButton onClick={handleCancel} size="small">
                            <Cancel color="error" />
                          </IconButton>
                        </>
                      ) : (
                        <>
                          <IconButton onClick={() => handleView(exp)} size="small">
                            <Visibility color="info" />
                          </IconButton>
                          <IconButton onClick={() => handleEdit(exp.id)} size="small">
                            <Edit color="primary" />
                          </IconButton>
                          <IconButton onClick={() => handleDelete(exp.id)} size="small">
                            <Delete color="error" />
                          </IconButton>
                        </>
                      )}
                    </Box>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25, 50]}
          component="div"
          count={experiences.length}
          page={page}
          onPageChange={handleChangePage}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Paper>

      {/* View Dialog for Tablet/Desktop */}
      <Dialog open={viewDialogOpen} onClose={() => setViewDialogOpen(false)} maxWidth="md" fullWidth>
        <DialogTitle>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Work />
            Work Experience Details
          </Box>
        </DialogTitle>
        <DialogContent>
          {selectedExperience && (
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Typography variant="h6" color="primary" gutterBottom>
                  {selectedExperience.companyName}
                </Typography>
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography variant="subtitle1"><strong>Previous Designation:</strong> {selectedExperience.previousDesignation}</Typography>
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography variant="subtitle1"><strong>Total Tenure:</strong> {calculateTenure(selectedExperience.tenureFrom, selectedExperience.tenureTo)}</Typography>
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography variant="subtitle1"><strong>Tenure From:</strong> {selectedExperience.tenureFrom}</Typography>
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography variant="subtitle1">
                  <strong>Tenure To:</strong> {selectedExperience.tenureTo || "Present"}
                  {!selectedExperience.tenureTo && <span style={{ color: '#ff9800', marginLeft: '5px' }}>&#9679;</span>}
                </Typography>
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography variant="subtitle1"><strong>Last CTC:</strong> {formatCurrency(selectedExperience.lastCTC) || "Not specified"}</Typography>
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography variant="subtitle1"><strong>College/University:</strong> {selectedExperience.collegeUniversity || "Not applicable"}</Typography>
              </Grid>
            </Grid>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setViewDialogOpen(false)} variant="contained">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default WorkExperience;